// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html

import firebase from 'firebase/app'
import 'firebase/firestore'

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyBHZNjQ77LMTsybcub0Eyu1LzpVI8AL3Qk',
  authDomain: 'shanghaikitchen-8afca.firebaseapp.com',
  databaseURL: 'https://shanghaikitchen-8afca.firebaseio.com',
  projectId: 'shanghaikitchen-8afca',
  storageBucket: 'shanghaikitchen-8afca.appspot.com',
  messagingSenderId: '700642656339',
  appId: '1:700642656339:web:80b7c218e1ac5b54b506a6',
  measurementId: 'G-6FKJK42ZLE'
}

firebase.initializeApp(config)

export const db = firebase.firestore()
